enum GetFeatureTypes {
    LED = 'LED',
    EXTENDED_LED = 'EXTENDED_LED',
    CLEANING = 'CLEANING',
    VIBRATION = 'VIBRATION',
    DIAGNOSTIC = 'DIAGNOSTIC',
    ADVANCED_DIAGNOSTIC = 'ADVANCED_DIAGNOSTIC',
    RESPONSIVE_DRAW = 'RESPONSIVE_DRAW',
    VAPE_CLOUD_SIZE = 'VAPE_CLOUD_SIZE',
    AUTOSTART = 'AUTOSTART',
    GESTURE = 'GESTURE',
    COUNTDOWN = 'COUNTDOWN',
    VAPE_SESSION = 'VAPE_SESSION',
    DEVICE_RENAME = 'DEVICE_RENAME',
    ABOUT_MY_DEVICE = 'ABOUT_MY_DEVICE',
    LOCATE_MY_DEVICE = 'LOCATE_MY_DEVICE',
    DEVICE_RESET = 'DEVICE_RESET',
    DEVICE_PARENT_PROTECTION = 'DEVICE_PARENT_PROTECTION',
    AEM_FLEX_BATTERY = 'AEM_FLEX_BATTERY',
    AEM_PAUSE_MODE = 'AEM_PAUSE_MODE',
    FLEX_PUFF = 'FLEX_PUFF',
}

export default GetFeatureTypes;
